module.exports = __webpack_public_path__ + "img/product5.73b0aaa8.png";